import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { AND, PER_NIGHT, FROM_PRICE_PER_PERIOD, MORE_INFO, ROOM_AMENITIES } from "../../../utils/default-strings";
import { Divider } from "../../elements/Divider";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { BlockPlaceholder } from "../../elements/BlockPlaceholder";
import { TextPlaceholder } from "../../elements/TextPlaceholder";
import { Link } from "../../elements/Link";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { Modal } from "../../elements/Modal";
import { ShowOn } from "../../layout/ShowOn";
import { Heading } from "../../typography/Heading";
import { Slideshow } from "../../media/Slideshow";
import { withResponsive } from "../../../utils/with-responsive";
import { getPricePerPeriodMarkup } from "../../../utils/get-price-per-period-markup";
import { getRoomFeaturesMarkup } from "./utils/getRoomFeaturesMarkup";
import { getModalContentMarkup } from "./utils/getModalContentMarkup";

var Component = function Component(_ref) {
  var amenities = _ref.amenities,
      amenitiesConjunctionText = _ref.amenitiesConjunctionText,
      amenitiesHeadingText = _ref.amenitiesHeadingText,
      description = _ref.description,
      extraFeatures = _ref.extraFeatures,
      features = _ref.features,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      isUserOnMobile = _ref.isUserOnMobile,
      name = _ref.name,
      moreInfoText = _ref.moreInfoText,
      periodText = _ref.periodText,
      pricePerPeriod = _ref.pricePerPeriod,
      pricePerPeriodPrefix = _ref.pricePerPeriodPrefix,
      ratingNumber = _ref.ratingNumber,
      images = _ref.images;
  return React.createElement(Card, {
    className: "has-room-type-gallery",
    fluid: true
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridColumn, {
    computer: 4,
    mobile: 12,
    verticalAlignContent: null
  }, isShowingPlaceholder ? React.createElement(BlockPlaceholder, {
    isFluid: true
  }) : React.createElement(Slideshow, {
    hasShadow: false,
    images: images,
    isRounded: false,
    isShowingBulletNavigation: false,
    willFill: true
  })), React.createElement(GridColumn, {
    computer: 8,
    mobile: 12
  }, React.createElement(Grid, {
    padded: true
  }, isShowingPlaceholder ? React.createElement(GridColumn, null, React.createElement(Divider, null), React.createElement(TextPlaceholder, {
    length: "short"
  }), React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(Divider, null), React.createElement(TextPlaceholder, {
    length: "short"
  }), React.createElement(Divider, null)) : React.createElement(Fragment, null, React.createElement(GridColumn, {
    computer: 12,
    floated: "left",
    mobile: 10
  }, React.createElement(Heading, null, name)), React.createElement(GridColumn, {
    only: "mobile",
    textAlign: "right",
    verticalAlignContent: "middle",
    width: 2
  }, React.createElement(Modal, {
    hasPadding: true,
    trigger: React.createElement(Icon, {
      color: "primary",
      isButton: true,
      isCircular: true,
      isColorInverted: true,
      name: ICON_NAMES.INFO,
      size: "small"
    })
  }, getModalContentMarkup(amenities, amenitiesConjunctionText, amenitiesHeadingText, description, extraFeatures, features, name, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber, images, isUserOnMobile))), getRoomFeaturesMarkup(isUserOnMobile, features), React.createElement(GridRow, null, React.createElement(GridColumn, {
    only: "tablet computer",
    verticalAlignContent: "bottom",
    width: 4
  }, React.createElement(Modal, {
    hasPadding: true,
    size: "small",
    trigger: React.createElement(Link, null, moreInfoText)
  }, getModalContentMarkup(amenities, amenitiesConjunctionText, amenitiesHeadingText, description, extraFeatures, features, name, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber, images, isUserOnMobile))), React.createElement(GridColumn, {
    textAlign: isUserOnMobile ? 'left' : 'right',
    width: 8
  }, React.createElement(Card.Description, null, getPricePerPeriodMarkup(pricePerPeriod, pricePerPeriodPrefix, periodText)), React.createElement(ShowOn, {
    mobile: true,
    parent: Divider
  })))))))));
};

Component.displayName = 'RoomType';
Component.defaultProps = {
  description: null,
  amenitiesConjunctionText: AND,
  amenitiesHeadingText: ROOM_AMENITIES,
  extraFeatures: [],
  isShowingPlaceholder: false,
  moreInfoText: MORE_INFO,
  periodText: PER_NIGHT,
  pricePerPeriodPrefix: FROM_PRICE_PER_PERIOD,
  ratingNumber: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  amenities: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  amenitiesConjunctionText: PropTypes.string,
  amenitiesHeadingText: PropTypes.string,
  description: PropTypes.string,
  extraFeatures: PropTypes.arrayOf(PropTypes.shape({
    labelText: PropTypes.string
  })),
  features: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string,
    labelText: PropTypes.string.isRequired
  })).isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired,
  isShowingPlaceholder: PropTypes.bool,
  isUserOnMobile: PropTypes.bool.isRequired,
  moreInfoText: PropTypes.string,
  name: PropTypes.string.isRequired,
  periodText: PropTypes.string,
  pricePerPeriod: PropTypes.string.isRequired,
  pricePerPeriodPrefix: PropTypes.string,
  ratingNumber: PropTypes.number
} : {};
export var ComponentWithResponsive = withResponsive(Component);